// extracted by mini-css-extract-plugin
export default {"input":"DataList_input__77OIt"};